<template>
  <div class="campus-list" data-test="choose-open-campus">
    <div class="tip flex-between" v-if="this.type==99">
        <div>
            <div>当前服务校区容量为{{companyInfo.companyProduct.currentCampusCapacity}}</div>
            <div>请选择要启用服务的{{companyInfo.companyProduct.currentCampusCapacity}}个校区</div>
        </div>
        <van-button plain square round type="primary" size="small" class="tip-btn" @click="goto" v-if="app.permission.op('expansion_campus')">去扩容</van-button>                
    </div>
    <div class="tip" v-if="this.type==1">
        当前可启用的校区数量为1，请选择启用校区
    </div>
    <div class="vlist"> 
        <van-checkbox-group v-model="result" :max="this.type==1?1:companyInfo.companyProduct.currentCampusCapacity">
            <div
                class="campus-wrapper flex-between"
                v-for="item in list"
                :key="item.id"        
            >
                <img class="item-photo" :src="item.logoImage?item.logoImage.url:''" alt="" />
                <div class="item-name van-ellipsis">
                    {{ item.name }}
                    <div class="default-tag" v-if="item.isDefault">默认</div>
                </div>
                <div class="item-choose"  v-if="user.superAdmin||user.admin">
                     <van-checkbox :name="item.id"></van-checkbox>                
                </div>
            </div>
        </van-checkbox-group>
    </div>

    <van-dialog v-model="showDialog" title="提示" :showConfirmButton="false">
        <div class="cost-dialog">
            <div class="top-tips flex-center">未被选择的校区将自动转为未启用的状态</div>
            <div class="btn-area">
                <div class="option flex-center primary" @click="update">确认选择</div>
                <div class="option flex-center" @click="goto" v-if="this.type==99">去扩容校区</div>
                <div class="option flex-center" @click="showDialog=false">取消</div>
            </div>        
        </div>
    </van-dialog>
    <pageFooterBtn btnText="确认选择" @click="submit"  v-if="user.superAdmin||user.admin"/>
  </div>
</template>

<script>
import pageFooterBtn from "@x3/vue/comp/page-footer-btn.vue";
export default {
  name: "chooseOpenCampus",
  components: { pageFooterBtn},
  computed: {
    ...Vuex.mapState(["companyInfo"]),
  },
  data() {
    return {
      pageTitle: "选择使用校区",
      list: [],
      user: app.teacher.user,
      result:[],
      showDialog:false,
      type: 1
    };
  },
  methods: {
    render(list, res) {
      this.showLoading();
      this.$api.getCampusList({
        type: 1
      }).then((res) => {
        if (res.code === 200) {
          this.list = res.data;
        } else {
          this.$toast.fail( res.msg );
        }
        vant.Toast.clear();
      });
    },
    submit(){     
        if (this.result.length == 0){
            this.$toast(`请至少选择1个校区`);            
        } else{
            this.showDialog = true;           
        }
    },
    update(){         
        let disableList = this.list.filter(item=>!this.result.some(id=>item.id == id)).map(item=>item.id);

        this.$api.batchUpdateExpireCampusStatus({
            enabledCampusIds: this.result,
            disabledCampusIds: disableList
        }).then(res=>{
            if (res.code == 200){
                app.teacher.refreshTo({
                    replace:true
                });
            }
        })  
    },
    goto(){
      app.teacher.gotoOpenBuy({
        selfType: 2
      })
    }
  },
  created() {
    this.type = this.$route.query.type;
    if (!this.companyInfo.companyProduct.campusChoice && this.type==99){            
        this.$router.replace("/home");
        return;
    }

    this.render();
    // let message = this.user.superAdmin ?  
    //     `您所在机构的校区容量调整为${this.companyInfo.companyProduct.currentCampusCapacity}个，目前校区数量已超过，请选择您要保留的校区`:
    //     `您所在机构的校区容量调整为${this.companyInfo.companyProduct.currentCampusCapacity}个，目前校区数量已超过，请联系管理员进行操作`,
    //     confirmButtonText = this.user.superAdmin ? '去选择' : '知道了';

    // this.$dialog({
    //     title:'提示',
    //     message,
    //     showCancelButton: false,
    //     confirmButtonText,
    // });
  },
  beforeDestroy() {

  },
};
</script>

<style lang="scss" scoped>
.campus-list {
  display: flex;
  flex-direction: column;
  .cost-dialog{
      padding-top: calc(var(--gap) * 8);
      padding-bottom: calc(var(--gap) * 12);
      .top-tips{
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        color:var(--g6);
      }

      .btn-area{
          margin-top:calc(var(--gap) * 12);
          .option{
              font-size:var(--fs-lg);
              line-height:var(--lh-lg);
              color:var(--g8);
              margin-top:calc(var(--gap) * 24);
              &.primary{
                  color:var(--c1);
              }
          }
      }
  }
}
.tip{
    background: var(--g1);
    padding:calc(var(--gap) * 16);
    font-size:var(--fs-sm);
    line-height:var(--lh-sm);
    color:var(--g7);
    .tip-btn{
        min-width: calc(var(--w) * 72);
        height: calc(var(--w) * 28);
    }
}
.vlist {
  flex: 1;
  position: relative;
  background: var(--g1);
  overflow-y: auto;
  font-size:var(--fs-md);
  line-height:var(--lh-md);
  .campus-wrapper {
    background-color: var(--white);
    position: relative;
    .item-photo {
      margin: calc(var(--gap) * 16) calc(var(--gap) * 8) calc(var(--gap) * 16) calc(var(--gap) * 16);
      width: calc(var(--w) * 40);
      height: calc(var(--w) * 40);
      border-radius: 50%;
      background: var(--g2);
    }
    .item-name {
      font-size:var(--fs-lg);
      line-height:var(--lh-lg);
      flex: 1;
      color: var(--g8);
      padding-right: calc(var(--gap) * 8);
      display: flex;
      align-items: center;
      .default-tag {
        background: rgba(var(--c1-rgb), 0.1);
        color: var(--c1);
        padding: 0 calc(var(--gap) * 8);
        border-radius: var(--radius-md);
        text-align: center;
        font-size:var(--fs-sm);
        line-height:var(--lh-sm);
        margin-left: calc(var(--gap) * 8);
      }
    }
    .item-choose {
      margin-right: calc(var(--gap) * 16);
    }
    &:not(:last-child)::after {
      position: absolute;
      content: ' ';
      pointer-events: none;
      right: 0;
      bottom: 0;
      left: 64px;
      border-bottom: 1px solid var(--g3);
      transform: scaleY(.5);
    }
  }
}
</style>